import { data } from '../../svg/ArrowLeft/data';
import { makeIcon } from '../makeIcon';

export const ArrowLeft = makeIcon(data, 'arrow_left', 'ArrowLeft');

export default ArrowLeft;
